/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PatchTeamsIdMutationRequest,
  PatchTeamsIdMutationResponse,
  PatchTeamsIdPathParams,
  PatchTeamsId401,
  PatchTeamsId403,
  PatchTeamsId404,
  PatchTeamsId500,
} from "../types/PatchTeamsId.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const patchTeamsIdMutationKey = () => [{ url: "/teams/:id" }] as const;

export type PatchTeamsIdMutationKey = ReturnType<
  typeof patchTeamsIdMutationKey
>;

/**
 * @summary Обновление информации о команде (название, тег, лого, описание)
 * {@link /teams/:id}
 */
export async function patchTeamsId(
  id: PatchTeamsIdPathParams["id"],
  data?: PatchTeamsIdMutationRequest,
  config: Partial<RequestConfig<PatchTeamsIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchTeamsIdMutationResponse,
    ResponseErrorConfig<
      PatchTeamsId401 | PatchTeamsId403 | PatchTeamsId404 | PatchTeamsId500
    >,
    PatchTeamsIdMutationRequest
  >({
    method: "PATCH",
    url: `/teams/${id}`,
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}

export function patchTeamsIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PatchTeamsIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = patchTeamsIdMutationKey();
  return mutationOptions<
    ResponseConfig<PatchTeamsIdMutationResponse>,
    ResponseErrorConfig<
      PatchTeamsId401 | PatchTeamsId403 | PatchTeamsId404 | PatchTeamsId500
    >,
    { id: PatchTeamsIdPathParams["id"]; data?: PatchTeamsIdMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return patchTeamsId(id, data, config);
    },
  });
}

/**
 * @summary Обновление информации о команде (название, тег, лого, описание)
 * {@link /teams/:id}
 */
export function usePatchTeamsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PatchTeamsIdMutationResponse>,
      ResponseErrorConfig<
        PatchTeamsId401 | PatchTeamsId403 | PatchTeamsId404 | PatchTeamsId500
      >,
      { id: PatchTeamsIdPathParams["id"]; data?: PatchTeamsIdMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PatchTeamsIdMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? patchTeamsIdMutationKey();

  const baseOptions = patchTeamsIdMutationOptions(config) as UseMutationOptions<
    ResponseConfig<PatchTeamsIdMutationResponse>,
    ResponseErrorConfig<
      PatchTeamsId401 | PatchTeamsId403 | PatchTeamsId404 | PatchTeamsId500
    >,
    { id: PatchTeamsIdPathParams["id"]; data?: PatchTeamsIdMutationRequest },
    TContext
  >;

  return useMutation<
    ResponseConfig<PatchTeamsIdMutationResponse>,
    ResponseErrorConfig<
      PatchTeamsId401 | PatchTeamsId403 | PatchTeamsId404 | PatchTeamsId500
    >,
    { id: PatchTeamsIdPathParams["id"]; data?: PatchTeamsIdMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PatchTeamsIdMutationResponse>,
    ResponseErrorConfig<
      PatchTeamsId401 | PatchTeamsId403 | PatchTeamsId404 | PatchTeamsId500
    >,
    { id: PatchTeamsIdPathParams["id"]; data?: PatchTeamsIdMutationRequest },
    TContext
  >;
}
